import { useQuery } from "react-query";
import { getAdminMails } from "../../api";
import { API_KEY_GET_ADMIN_CHATS } from "../../helpers";

export const useGetAdminMails = (type, params) => {
  return useQuery([API_KEY_GET_ADMIN_CHATS, type, params], () =>
    getAdminMails(type, params)
  );
};
